import React from 'react'
import { useLocation } from 'react-router-dom'
import { AsistenciaContextProvider } from '../../../context/AsistenciaContext'
import { TechnicalAssistanceProvider } from '../../../context/TechnicalAssistanceContext'
import AsistenciaTecnica from './AsistenciaTecnica'

const FormAsistencia = () => {
  const location = useLocation()

  return (
    <>
      <AsistenciaContextProvider>
        <TechnicalAssistanceProvider>
          <AsistenciaTecnica
            idForm={location.state.idForm}
            edit={location.state.edit}
          />
        </TechnicalAssistanceProvider>
      </AsistenciaContextProvider>
    </>
  )
}

export default FormAsistencia
